import { render, staticRenderFns } from "./ZendeskTaskDetail.vue?vue&type=template&id=7c6b76be"
import script from "./ZendeskTaskDetail.vue?vue&type=script&lang=js"
export * from "./ZendeskTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports